<template>
<div id="app" style="height: 100%;">
    <div id="nav">

    </div>
    <router-view />
</div>
</template>

<script>
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-balham.css'
export default {
    watch: {
        'navigator.onLine'() {
            console.log("navigator", navigator);
            console.log("navigator.onLine", navigator.onLine);
            
        }
    }
}
</script>


